var map = {
	"./arrow.svg": 509,
	"./calendar.svg": 510,
	"./close.svg": 511,
	"./h2-pedo-logo.svg": 512,
	"./logo-active.svg": 513,
	"./logo-footer.svg": 514,
	"./logo.svg": 515,
	"./phone.svg": 516,
	"./quotes.svg": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 601
// module chunks = 1